export default __webpack_public_path__ + "static/media/testifyTen.99528b24.png";